import { useEffect } from 'react'
import { searchDateTimeSelector } from 'search-date-time'

import { CARDS } from '../reducers'
import { withRouter } from 'i18n/utils'

import RateList from './RateList/RateList'
import { PromoCode } from './PromoCode'

import Button from '@components/Button'
import { CardSection } from '@components/CardSection'
import { DateTimeRange } from 'shared/components/TimePicker'
import ErrorMessage from 'shared/components/ErrorMessage'

import { startOfWeekSelector } from '@settings/selectors'
import withRates from '@booking/components/withRates'

import {
    lastBookingBasketItemSelector,
    promoCodeBarcodeSelector,
    rateSelector,
    rawPromoCodeSelector,
    waitingListKeySelector,
} from '@booking/selectors'
import { lastBookingRedeemPromoCode, lastBookingRemovePromoCode, setRawPromoCode } from '@booking/actions'
import { SHOW_HOURLY_FLOW } from '@booking/constants'

import { numberOfItemsSelector } from 'basket/selectors'
import { pendingSelector } from 'api/selectors'

const HourlySelection = ({
    rate,
    range: { start, end },
    startOfWeek,
    disabledCards,
    promoCodeBarcode,
    rawPromoCode,
    setRawPromoCode,
    selectedRateId,
    ratesPending,
    makePurchasePending,
    filteredRates,
    areRatesPending,
    ratesError,
    onRateSelected,
    onDateRangeChange,
    lastBookingRedeemPromoCode,
    lastBookingRemovePromoCode,
    numberOfItemsInBasket,
    promoCodePending,
    waitingListKey,
    lastBookingBasketItem,
    enableCard,
}) => {
    const currentItemIndex = numberOfItemsInBasket + 1
    const isPromoCodePending = promoCodePending[`redeemPromoCode${currentItemIndex}`]
    const promoCodeError = isPromoCodePending instanceof Error ? isPromoCodePending.message : ''

    useEffect(() => {
        lastBookingRemovePromoCode()

        if (rawPromoCode) {
            lastBookingRedeemPromoCode({
                id: currentItemIndex,
                rate: { ...rate, waitingListKey },
            })
        }
    }, [rate])

    const onConfirmBookingTime = () => {
        enableCard([CARDS.AVAILABLE_PRODUCTS, CARDS.SELECT_PARKING_TIME])
    }

    const onAddPromoCode = () => {
        lastBookingRedeemPromoCode({
            id: currentItemIndex,
            rate: { ...rate, waitingListKey },
        })
    }

    //PRICE
    const promoCodeDiscount =
        lastBookingBasketItem && lastBookingBasketItem.promoCode && !isPromoCodePending
            ? lastBookingBasketItem.promoCode.promoDiscount
            : 0
    const discountedRateId =
        lastBookingBasketItem && lastBookingBasketItem.rate ? lastBookingBasketItem.rate.rateId : null

    const rates = filteredRates.filter(rate => {
        const defaultCustomerFlowArr = rate.defaultCustomerFlow.split('|')
        return !!defaultCustomerFlowArr.some(element => SHOW_HOURLY_FLOW.includes(element))
    })

    return (
        <>
            <CardSection className="search-bar confirm" title={<T>booking.select.parking.time</T>}>
                <DateTimeRange
                    startOptions={{
                        disabled: makePurchasePending === true,
                        datePickerOptions: { label: <T>label.parking.start</T> },
                        timePickerOptions: { label: <T>label.datetime.info</T> },
                    }}
                    endOptions={{
                        disabled: makePurchasePending === true,
                        datePickerOptions: { label: <T>label.parking.end</T> },
                        timePickerOptions: { label: <T>label.datetime.info</T> },
                    }}
                    startOfWeek={startOfWeek}
                    start={start}
                    end={end}
                    onChange={onDateRangeChange}
                />
                {disabledCards[CARDS.SELECT_PARKING_TIME] && (
                    <div className="row">
                        <div className="col-xs-12 col-sm-3">
                            <Button size="large" block onClick={onConfirmBookingTime}>
                                <T>booking.btn.confirm.booking.time</T>
                            </Button>
                        </div>
                    </div>
                )}
            </CardSection>
            {(!disabledCards[CARDS.AVAILABLE_PRODUCTS] && ratesError) || (!areRatesPending && rates.length === 0) ? (
                <ErrorMessage messages={[ratesError ? ratesError : <T>booking.error.rates.not.found</T>]} />
            ) : (
                <CardSection
                    disabled={disabledCards[CARDS.AVAILABLE_PRODUCTS]}
                    loading={areRatesPending}
                    title={<T>booking.avail.products.label</T>}>
                    <RateList
                        discountedRateId={discountedRateId}
                        promoCodeDiscount={promoCodeDiscount}
                        selectRate={onRateSelected}
                        rates={rates}
                        selectedRateId={selectedRateId}
                        disabled={(ratesPending && !(ratesPending instanceof Error)) || makePurchasePending === true}
                    />
                    <div className="d-inline-flex mt-4 p-0">
                        <PromoCode
                            promoCodeValue={rawPromoCode}
                            setRawPromoCode={setRawPromoCode}
                            rate={selectedRateId}
                            onRemovePromoCode={lastBookingRemovePromoCode}
                            onAddPromoCode={onAddPromoCode}
                            label={<T>booking.promocode.title</T>}
                            removePromoCodeLabel={<T>booking.promocode.remove</T>}
                            btnLabel={<T>booking.promocode.add</T>}
                            placeholder={<T>booking.promocode.placeholder</T>}
                            error={promoCodeError}
                            success={!!promoCodeBarcode}
                            disabled={
                                !rate ||
                                (ratesPending && !(ratesPending instanceof Error)) ||
                                makePurchasePending === true
                            }
                            isLoading={isPromoCodePending === true}
                        />
                    </div>
                </CardSection>
            )}
        </>
    )
}

export default compose(
    withRouter,
    connect(
        createStructuredSelector({
            range: searchDateTimeSelector,
            startOfWeek: startOfWeekSelector,
            numberOfItemsInBasket: numberOfItemsSelector,
            promoCodePending: pendingSelector,
            waitingListKey: waitingListKeySelector,
            lastBookingBasketItem: lastBookingBasketItemSelector,
            rate: rateSelector,
            promoCodeBarcode: promoCodeBarcodeSelector,
            rawPromoCode: rawPromoCodeSelector,
        }),
        {
            lastBookingRedeemPromoCode,
            lastBookingRemovePromoCode,
            setRawPromoCode,
        }
    )
)(withRates(HourlySelection))
